import React, { useEffect, useState } from "react";
import { FormGroup, Button, Container, Spinner } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { FetchFeeByType, UpdateFee } from "../../apis/Fee";

const Vat = () => {
  const [updateData, setUpdateData] = useState({
    _id: "",
    value: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      try {
        const response = await FetchFeeByType("vat");
        if (response && response.data) {
          const fees = response.data.fees;
          setUpdateData({
            _id: fees[0]._id,
            value: fees[0].value,
          });
        }
      } catch (error) {
        toast.error("Failed to fetch data");
        console.error(error);
      } finally {
        setLoading(false); // Stop loading
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); // Start loading when submitting

    const data = {
      feeId: updateData._id,
      valueType: "percentage",
      value: updateData.value,
    };

    const response = await UpdateFee(data);
    if (response) {
      toast.success("Vat Updated Successfully");
      navigate("/vat");
    } else {
      toast.error("Vat Creation Failed");
    }
    setLoading(false); // Stop loading after submission
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        {loading ? (
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <div className="p-6 flex flex-col gap-6 ">
            <h1 className="text-2xl dark:text-[#c7d8eb]">Manage Vat</h1>
            <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
              <AvForm onValidSubmit={handleSubmit}>
                <div className="mb-3">
                  <AvField
                    className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                    name="vat"
                    label="VAT"
                    placeholder="Type VAT Value"
                    type="number"
                    errorMessage="Enter a valid number"
                    validate={{
                      required: { value: true },
                      pattern: {
                        value: /^\d+(\.\d{1,2})?$/,
                        errorMessage:
                          "Only numbers with up to 2 decimal places allowed",
                      },
                      min: {
                        value: 1,
                      },
                      max: {
                        value: 100,
                      },
                    }}
                    value={updateData.value}
                    onChange={(e) =>
                      setUpdateData({
                        ...updateData,
                        value: e.target.value,
                      })
                    }
                  />
                </div>

                <FormGroup className="mb-0">
                  <div className="d-flex justify-content-end">
                    <Button type="submit" color="primary" className="me-1 px-4">
                      Save
                    </Button>{" "}
                  </div>
                </FormGroup>
              </AvForm>
            </div>
          </div>
        )}
      </Container>
      </div>
    </React.Fragment>
  );
};

export default Vat;
